var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.share.length > 0)?_c('div',{staticClass:"ctrl-btns"},[_c('a',{attrs:{"title":_vm.$locale('global.delete')},on:{"click":function($event){return _vm.reduce_fn('DEL')}}},[_c('i',{staticClass:"el-icon-minus"})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }